module.exports = __webpack_public_path__ + "media/images/avatar/3-3a77821bcf2afc38acd2d12f71ef7800.svg";